import _styled from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
export var Wrapper = function Wrapper(_ref) {
  var children = _ref.children,
      id = _ref.id;
  return /*#__PURE__*/_jsx(WrapperClass, {
    id: id,
    children: children
  });
};
export default Wrapper;

var WrapperClass = /*#__PURE__*/_styled.div.withConfig({
  displayName: "wrapper__WrapperClass",
  componentId: "sc-vr0cvc-0"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem"
});